class PodcastBanner {
  constructor() {
    this.section = document.querySelector(".section--podcast-banner");
    if (!this.section) return;

    this.layer = this.section.querySelector(".podcast-banner__bg-layer");
    if (!this.layer) return;

    this.bgItems = [
      ...this.section.querySelectorAll(".podcast-banner__bg-item"),
    ];

    this.entrance();
    this.setup();
  }

  entrance() {
    const titleEl = this.section.querySelector(".podcast-banner__title");
    const subtitleEl = this.section.querySelector(".podcast-banner__subtitle");
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const isDesktop = window.matchMedia("(min-width: 1200px)").matches;

    /* Mobile / reduced-motion: reveal everything immediately */
    if (prefersReduced || !isDesktop) {
      gsap.set(this.bgItems, { opacity: 1 });
      if (titleEl) gsap.set(titleEl, { opacity: 1 });
      if (subtitleEl) gsap.set(subtitleEl, { opacity: 1 });
      return;
    }

    const imgs = this.bgItems
      .map((item) => item.querySelector("img"))
      .filter(Boolean);

    /* ── "Pixel Perfect" — per-char rotateX entrance ── */
    let titleChars = [];
    if (titleEl && typeof SplitText !== "undefined") {
      const split = new SplitText(titleEl, { type: "chars" });
      titleChars = split.chars;
      /* Reveal parent first so chars are in the render tree */
      gsap.set(titleEl, { opacity: 1 });
      gsap.set(titleChars, {
        rotateX: 90,
        opacity: 0,
        transformOrigin: "50% 100%",
      });
    }

    if (subtitleEl) gsap.set(subtitleEl, { y: 20, opacity: 0 });
    gsap.set(imgs, { scale: 0.88 });

    const tl = gsap.timeline();

    /* 1 — letters rotate from 90° back to 0° */
    if (titleChars.length) {
      tl.to(titleChars, {
        rotateX: 0,
        opacity: 1,
        stagger: 0.04,
        duration: 0.65,
        ease: "back.out(2)",
      });
    }

    /* 2 — "Podcast" subtitle slides up */
    if (subtitleEl) {
      tl.to(
        subtitleEl,
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power3.out",
        },
        "-=0.3",
      );
    }

    /* 3 — background images stagger in only after text + subtitle are done */
    tl.to(
      this.bgItems,
      {
        opacity: 1,
        duration: 0.65,
        stagger: 0.12,
        ease: "power2.out",
      },
      ">",
    );

    tl.to(
      imgs,
      {
        scale: 1,
        duration: 0.8,
        stagger: 0.12,
        ease: "power2.out",
        clearProps: "transform",
      },
      "<",
    );
  }

  setup() {
    this.section.addEventListener("mousemove", this.onMove.bind(this));
  }

  onMove(e) {
    const rect = this.section.getBoundingClientRect();
    const w = rect.width;
    const h = rect.height;
    const nx = (e.clientX - rect.left - w / 2) / (w / 2);
    const ny = (e.clientY - rect.top - h / 2) / (h / 2);

    const tx = -0.25 * w * nx;
    const ty = -0.25 * h * ny;

    gsap.to(this.layer, {
      x: tx,
      y: ty,
      duration: 1.2,
      ease: "power3.out",
      overwrite: "auto",
    });
  }
}

new PodcastBanner();
